import React, {useEffect, useState} from "react"
import PropTypes from 'prop-types'
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Button,
  Alert,
  Spinner
} from "reactstrap"
import Select from "react-select"
import { useSelector, useDispatch } from "react-redux"
import { getAllCoas as onGetAllCoa } from "store/products/actions"

const COADropDown = props => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(onGetAllCoa(true))
  }, [dispatch]);

  const { coaList } = useSelector(state => ({
    coaList: state.Products.coaList
  }))

  const [coaDropDownList, setCoaDropDownList] = useState([])
  const [selectedOption, setSelectedOption] = useState({})

  useEffect(() => {
    props.selectOnChange(selectedOption)
  }, [selectedOption]);

  useEffect(() => {
    const groupArray = props.groupCode.split(',')
    //const filteredList = coaList.filter(each => each.groupDetails.groupCode == props.groupCode)
    const filteredList = coaList.filter(each => groupArray.includes(each.groupDetails.groupCode))
    //console.log('filteredList:'+JSON.stringify(filteredList))
    let tempList = []
    filteredList.forEach(element => {
      tempList.push({
        label:element.accountName,
        value:element.id,
        groupname: element.groupDetails.groupName
      })
      if(props.id && props.id != ""){
        if(props.id == element.id){
          setSelectedOption({
            label:element.accountName,
            value:element.id,
            //groupname: element.groupDetails.groupName
          })
          /*
          props.selectOnChange({
            label:element.accountName,
            value:element.id
          })
          */
        }
      }
      else if(props.accountType){
        if(props.accountType == element.accountType){
          setSelectedOption({
            label:element.accountName,
            value:element.id,
            //groupname: element.groupDetails.groupName
          })
          /*
          props.selectOnChange({
            label:element.accountName,
            value:element.id
          })
          */
        }
      }
    });
    setCoaDropDownList(tempList)
    
  }, [coaList,props.id]);

  const formatOptionLabel = ({ value, label, groupname }) => (
    <div style={{ display: "flex", justifyContent: "space-between"}}>
      <div>{label}</div>
      <div style={{ marginLeft: "10px", color: "#ccc" }}>
        {groupname}
      </div>
    </div>
  );

  return (
    <React.Fragment>
      <Select
        value={selectedOption}
        isDisabled={props.disabled}
        onChange={(e) => {
          props.selectOnChange(e)
          setSelectedOption({
            label:e.label,
            value:e.value,
            //groupname: e.groupDetails.groupName
          })
        }}
        options={coaDropDownList}
        formatOptionLabel={formatOptionLabel}
        classNamePrefix="select2-selection"
      />
    </React.Fragment>
  )
}

COADropDown.propTypes = {
  id:PropTypes.any,
  accountType: PropTypes.any,
  groupCode:PropTypes.any,
  selectOnChange: PropTypes.func,
  selectedValue: PropTypes.any
}

export default COADropDown
